import React, { useState } from "react";

const ScrollingNotice = () => {
  const [isHovered, setIsHovered] = useState(false);
  
  const noticeText = `We're working hard to bring you a fresh, original, and upgraded experience.  
Some pages may look incomplete for now — but the full version is launching soon .............`;

  return (
    <div className="overflow-hidden whitespace-nowrap bg-yellow-50 border-t border-b border-yellow-200 py-2">
      <div 
        className="inline-block animate-scroll px-4 text-red-600 font-medium"
        style={{
          animationPlayState: isHovered ? 'paused' : 'running'
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {noticeText} &nbsp;&nbsp;&nbsp; {noticeText} &nbsp;&nbsp;&nbsp; {noticeText}
      </div>

      <style>{`
        @keyframes scroll {
          0% {
            transform: translateX(0%);
          }
          100% {
            transform: translateX(-33.333%);
          }
        }
        .animate-scroll {
          display: inline-block;
          white-space: nowrap;
          animation: scroll 15s linear infinite;
        }
      `}</style>
    </div>
  );
};

export default ScrollingNotice;
